import { getProduct } from '@/api/product';
import { getTemplateProduct } from '@/api/admin/templateProducts';
import { getProductBase } from '@/api/templateProduct';
import { getDesignTemplate } from '@/api/admin/designTemplates';
import { getPodProviderById } from '@/api/admin/podProvider';
import { getMyProductBasesPod } from '@/api/podProvider';

type DesignStudioConfig = {
    forProductTemplateCreation: boolean;
    forMyProductBases: boolean;
    forDesignTemplateCreation: boolean;
    isChildTemplateProduct: boolean;
    pod: string;
    previewMode: boolean;
};

export default function useDesignStudio(config: DesignStudioConfig) {
    const {
        forProductTemplateCreation,
        forMyProductBases,
        forDesignTemplateCreation,
        pod,
        isChildTemplateProduct,
        previewMode
    } = config;

    function fetchTemplate(templateId: string) {
        if (previewMode) {
            throw new Error('Cannot fetch template in preview mode, unsupported operation.');
        }

        if (forProductTemplateCreation && forMyProductBases) {
            console.log(`Loading product base ${templateId}`);
            return getProductBase(templateId, isChildTemplateProduct);
        }

        if (forProductTemplateCreation && !forMyProductBases) {
            console.log(`Loading template product ${templateId}`);
            return getTemplateProduct(templateId, pod, isChildTemplateProduct);
        }

        if (forDesignTemplateCreation) {
            console.log(`Loading design template ${templateId}`);
            return getDesignTemplate(templateId);
        }

        console.log(`Loading template ${templateId}`);
        return getProduct(templateId);
    }

    function getPodProvider(id?: number) {
        if (forProductTemplateCreation && !forMyProductBases && id) {
            return getPodProviderById(id);
        }

        if (forMyProductBases) {
            return getMyProductBasesPod();
        }

        return undefined;
    }

    return { fetchTemplate, getPodProvider };
}
